import { Flex, type FlexProps } from '@/ui';

export const CountBadge = (props: FlexProps) => (
  <Flex
    align="center"
    bg="magicPurple.500"
    borderRadius="ah-pill"
    color="white"
    fontSize="ah-label"
    fontWeight={700}
    justify="center"
    lineHeight="normal"
    minH="20px"
    minW="20px"
    pos="absolute"
    px="1.5"
    py="0.5"
    right="-4px"
    top="-8px"
    {...props}
  />
);
